import {getApiUrl} from "../../../utils/AuthUtils";

const MASTERS_BASE_URL = `${getApiUrl()}/api/masters`;

export const MASTERS_API = {
    ENTITY_MASTER: `${MASTERS_BASE_URL}/entity-masters`,
    LEAD_MASTER: `${MASTERS_BASE_URL}/lead-masters`,
    USER_GROUP_MASTERS: `${MASTERS_BASE_URL}/user-groups-masters`,

}